import { axios } from '@/utils/request'
/**
 * 获取代理人
 */
export function MyProxy(data = {}) {
  return axios({
    url: '/finsaas-ems/user-proxy/my-proxy',
    method: 'post',
    data
  })
}

export function SetProxy(data = {}) {
  return axios({
    url: '/finsaas-ems/user-proxy/enter',
    method: 'post',
    data
  })
}

export function ExitProxy(data = {}) {
  return axios({
    url: '/finsaas-ems/user-proxy/exit',
    method: 'post',
    data
  })
}
